import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var createWarningCircleOutline = function (width, height) {
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "12", cy: "12", r: "9.5", stroke: "#101010" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 14.5H12.5L12.5 6.5H11.5V14.5ZM12.5 16.5H11.5V17.5H12.5V16.5Z", fill: "#101010", "data-testid": "WarningCircleOutline" })));
};
var s = createWarningCircleOutline(12, 12);
var m = createWarningCircleOutline(16, 16);
var l = createWarningCircleOutline(24, 24);
var xl = createWarningCircleOutline(32, 32);
var notice = createWarningCircleOutline(48, 48);
var WarningCircleOutline = createIconComponent({ s: s, m: m, l: l, xl: xl, notice: notice });

export { WarningCircleOutline as default };
//# sourceMappingURL=WarningCircleOutline.js.map
